import React from 'react'
import Typography from 'aldoo-ra/Typography'

const DetailsTab = ({ release }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A'
    return new Date(dateString).toLocaleString()
  }

  const detailsRows = [
    { label: 'Release ID', value: release._id },
    { label: 'Name', value: release.name },
    { label: 'Description', value: release.description || 'N/A' },
    { label: 'Status', value: release.status },
    { label: 'Created At', value: formatDate(release.createdAt) },
    { label: 'Scheduled At', value: formatDate(release.scheduledAt) },
    { label: 'Started At', value: formatDate(release.startedAt) },
    { label: 'Completed At', value: formatDate(release.completedAt) },
    { label: 'Audience Size', value: release.audienceSize?.toLocaleString() || '0' },
    { label: 'Base Audience Size', value: release.baseAudienceSize?.toLocaleString() || '0' },
    { label: 'Audience Share', value: release.audienceShare ? `${release.audienceShare}%` : 'N/A' },
    { label: 'Segments', value: release.segments?.join(', ') || 'N/A' },
    { label: 'Include Unregistered', value: release.includeUnregistered ? 'Yes' : 'No' },
    { label: 'Target Languages', value: release.targetLanguages?.length ? release.targetLanguages.join(', ') : 'All' },
    { label: 'Target Platforms', value: release.targetPlatforms?.length ? release.targetPlatforms.join(', ') : 'All' }
  ]

  return (
    <div className="space-y-4">
      <div className="bg-admin_canvas rounded-lg p-4">
        <Typography variant="admin_label" className="mb-4">Release Information</Typography>
        <div className="space-y-3 max-h-[400px] overflow-y-auto scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_canvas">
          {detailsRows.map((row, index) => (
            <div key={index} className="flex items-start border-b border-admin_bordered pb-3 last:border-b-0 last:pb-0">
              <div className="w-1/3">
                <Typography variant="admin_txt2_dim">{row.label}</Typography>
              </div>
              <div className="w-2/3">
                <Typography variant="admin_txt2" className="break-words">
                  {row.value}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default React.memo(DetailsTab)
